<template>
  <section class="ApplicationReviewSection" v-if="isSectionVisible(section)">
    <div v-if="isSectionVisible(section)" @click="open = !open" :class="'sectionHeader' + (open ? ' open' : '')">
      <h3>
        <button :aria-expanded="open.toString()" :class="isAlert()" v-focus="sectionToFocus">
          <span class="icon--square primary white--text mr-2">{{open?'-':'+'}}</span>
          {{ section.label }}
          <span class="sr-only" v-if="isAlert()">Incomplete</span>
          <font-awesome-icon
            focusable="false"
            class="icon"
            icon="exclamation-circle"
            v-if="isAlert()"
          />
        </button>
      </h3>
      <button type="button" @click.stop="editSection(section)">Edit section</button>
    </div>

    <div v-if="isSectionVisible(section)" v-show="open" :id="section.id + '-fields'" class="fields">
      <ApplicationReviewRow
        v-for="field in section.fields"
        :key="field.apiKey"
        :section="section"
        :field="field"
        :alerts="alerts"
      />
    </div>
  </section>
</template>

<script>
import ApplicationReviewRow from '@/components/application/ApplicationReviewRow.vue'

export default {
  name: 'ApplicationReviewSection',
  components: {
    ApplicationReviewRow
  },
  props: ['section', 'fields', 'alerts'],
  data() {
    return {
      open: true
    }
  },
  computed: {
    application() {
      return this.$store.state.application || {}
    },
    alertBySection() {
      return this.alerts.filter(item => item.section.id === this.section.id && this.isSectionVisible(this.section)) 
    },
    sectionToFocus() {
      return this.$store.state.focusID === this.section.id
    }
  },
  methods: {
    isAlert() {
      
      if(this.isSectionVisible(this.section)){
        
        if (this.alertBySection.length > 0) {
          return 'error'
        }
      }
    },
    getAlertByField(field) {
      if(this.isSectionVisible(this.section)){
      return this.alertBySection.find(
        item => item.field.apiKey === field.apiKey
      )
      }
    },
    editSection(section) {
      this.$store.dispatch('set', [
        'application.meta.sectionExpandedId',
        section.id
      ])

      this.$scrollTo('#app', 1)

      this.$store.commit('set', ['auth.isUserActive', true])
      this.$store.commit('set', ['auth.isUserActiveTime', new Date().getTime()])

    },
    isSectionVisible(section) {
      if(section.id === 'shelter'){
      const service = this.$store.state.application.services.type
      if (service && service.find(item => item === 'rentMortgage' || item === 'securityDeposit')) {
          return service.find(item => item === 'rentMortgage' || item === 'securityDeposit') .length > 0       
      }
     }else{
      return  true
      }
     }
  },
  watch: {
    alerts(data) {
      // only reset if there are allerts
      if (data.length > 0) {
        this.open = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ApplicationReviewSection {
  margin-right: $content-padding;
  margin-left: $content-padding;
  padding-top: $content-padding * 1.25;
  padding-bottom: $content-padding * 1.25;
  border-bottom: 1px solid $color-bg-app;

  .sectionHeader {
    cursor: pointer;
    display: flex;
    align-items: center;

    > h3 {
      display: inline-block;
      margin: 0;
      font-weight: $text-normal;
      font-size: 2rem;
      vertical-align: middle;
      flex: 1 1 auto;

      .icon--square {
        width: 30px;
        height: 30px;
        flex: 0 0 30px;
        border-radius: 3px;
        font-weight: 700;
        font-size: 2rem;
        text-align: center;
        line-height: 30px;
      }

      > button {
        @include button-reset;

        display: flex;
        align-items: center;
        .icon {
          margin-left: 1rem;
        }
        &.error {
          color: $color-red;
          background-color: transparent !important;
        }
      }
    }

    > button {
      margin: 0;
      height: 30px;
      border: none;
      font-weight: 300;
      font-size: 1.6rem;
      margin-left: auto;
      flex: 0 0 120px;
    }
  }
}
@include mobile {
  .ApplicationReviewSection {
    .sectionHeader {
      h3 {
        width: 170px;
        button {
          text-align: left;
        }
      }
    }
  }
}

@include iphone-5 {
  .ApplicationReviewSection {
    .sectionHeader {
      h3 {
        width: 123px;
        button {
          font-size: 15px;
        }
      }
      > button {
        font-size: 15px;
      }
    }
  }
}
</style>
